import React, { useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import Carousel from 'react-multi-carousel';
import CarouselMultiButtonGroup from 'components/carousel-multi/carousel-multi-button-group';

import './carousel-multi.scss';

const CarouselMulti: React.FC<{
    swipeable: boolean;
    draggable: boolean;
    slideNumberOnDesktop: number;
    slideNumberOnTablet?: number;
    slideNumberOnMobile: number;
    arrows: boolean;
    renderButtonGroupOutside: boolean;
    isSlideIndicator?: boolean;
    autoplay?: boolean;
    showDots?: boolean;
    renderDotsOutside?: boolean;
    children: React.ReactNode;
}> = ({
    swipeable,
    draggable,
    slideNumberOnDesktop,
    slideNumberOnTablet,
    slideNumberOnMobile,
    arrows,
    renderButtonGroupOutside,
    children,
    isSlideIndicator,
    autoplay,
    showDots,
    renderDotsOutside
}) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: api.getDevice() === 'mobile' ? slideNumberOnTablet || slideNumberOnMobile : slideNumberOnDesktop
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: slideNumberOnTablet || slideNumberOnMobile
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: slideNumberOnMobile
        }
    };

    return (
        <Carousel
            responsive={responsive}
            swipeable={swipeable}
            draggable={draggable}
            slidesToSlide={api.getDevice() === 'mobile' ? slideNumberOnMobile : slideNumberOnDesktop}
            renderButtonGroupOutside={renderButtonGroupOutside}
            autoPlay={autoplay}
            customButtonGroup={arrows ? null : <CarouselMultiButtonGroup isSlideIndicator={isSlideIndicator} />}
            arrows={arrows}
            showDots={showDots}
            renderDotsOutside={renderDotsOutside}
        >
            {children}
        </Carousel>
    );
};

export default CarouselMulti;
